module.exports = __webpack_public_path__ + "static/img/brees-2011-slide-7.5d3617d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2011-slide-7.jpg
// module id = DTFX
// module chunks = 1